<template>
  <!-- v-if="checkPermission(['designation','PUT'])" -->
  <div>
    <span
      class="text-center table-edit-icon"
      @click="showModal"
      v-if="this.params.data.organization_id > 0"
    >
      <i class="text-center material-icons">edit</i>
    </span>
    <h5 class="text-center mt-3" v-else>--</h5>

    <div class="centerx">
      <vs-popup
        :id="'popmodal' + params.data.status_id"
        class="holamundo editModal"
        title="Update Status"
        :active.sync="popupActive"
      >
        <form>
          <FocusLock>
            <div class="vx-row">
              <!-- LEFT SIDE -->
              <div class="col-12">
                <div class="vx-row mb-6">
                  <div class="col-4 text-right align-self-center">
                    <h5 class="mb-0">Status Name*</h5>
                  </div>
                  <div class="col-7">
                    <div class>
                      <vs-input
                        v-validate="'required'"
                        name="Status name"
                        v-model="form.status_name"
                        class="w-full"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Status name')"
                        >{{ errors.first("Status name") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <!-- LEFT SIDE -->
              <div class="col-12">
                <div class="vx-row mb-6">
                  <div class="col-4 text-right align-self-center">
                    <h5 class="mb-0">Status Color*</h5>
                  </div>
                  <div class="col-7">
                    <div class>
                      <input type="color" v-model="form.status_color" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SUBMIT BUTTON -->
            <div class="vx-row">
              <div class="vx-col mx-auto">
                <!-- :disabled="submitStatus" -->
                <vs-button
                  :disabled="submitStatus"
                  type="filled"
                  @click.prevent="submitForm"
                  class="mr-3"
                  >Update</vs-button
                >

                <!-- <vs-button color="warning" type="border" class @click.prevent="clearForm">Reset</vs-button> -->
              </div>
            </div>
          </FocusLock>
        </form>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ContractService from "@/services/ContractService.js";
import companyService from "@/services/companyService.js";
export default Vue.extend({
  data() {
    return {
      switch1: true,
      submitStatus: true,
      form: {
        status_name: "",
        status_id: "",
        status_isactive: "1",
      },

      companies: [],
      popupActive: false,
      params: null,
      value: null,
      count: 0,
    };
  },
  watch: {
    form: {
      handler: function (newVal, oldVal) {
        if (this.count > 0) {
          this.submitStatus = false;
        }
        this.count++;
      },
      deep: true,
    },
  },
  computed: {
    OrganizationID() {
      return window.localStorage.getItem("OrganizationID");
    },
  },
  beforeMount() {
    console.log(
      "this.form, this.params.data :",
      this.form,
      this.params.data.status_id
    );
    this.value = this.params.value;
    this.form = this.params.data;
    // this.getCompanyList();
  },
  beforeDestroy() {
    let _id = document.getElementById("popmodal" + this.params.data.status_id);
    _id.setAttribute("style", "display: none;");
  },
  methods: {
    showModal() {
      this.popupActive = true;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.$vs.loading();
        if (result) {
          this.submitStatus = true;
          let id = this.form.status_id;
          let payload = {
            status_name: this.form.status_name,
            status_color: this.form.status_color,
            status_id: this.form.status_id,
            budget_isActive: this.params.data.budget_isActive,

            status_isactive: this.params.data.status_isactive,
          };

          ContractService.editContractVendor(payload, id)
            .then((response) => {
              this.$vs.loading.close();
              this.submitStatus = false;
              const { data } = response;
              this.popupActive = false;
              if (data.Status == true || data.Status == "true") {
                this.$vs.notify({
                  title: "Updated!",
                  text: data.Message,

                  iconPack: "feather",
                  icon: "check_box",
                  color: "success",
                });
                setTimeout(() => {
                  eventBus.$emit("conrefreshTableStatus", data);
                }, 1);
                this.clearForm();
              } else {
                this.$vs.loading.close();
                console.log("data :", data);
                this.$vs.notify({
                  title: "Error!",
                  text: data.Message,

                  iconPack: "feather",
                  icon: "check_box",
                  color: "warning",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.submitStatus = true;
              console.log("error :", error);
            });
          // if form have no errors
          // alert("form submitted!");
        } else {
          // form have errors
        }
      });
    },

    clearForm: function () {
      Object.keys(this.form).map((x, index) => {
        /_active/.test(x) ? (this.form[x] = "1") : (this.form[x] = "");
      });
      this.$validator.reset();
    },
  },

  mounted() {},
});
</script>
<style></style>
